import React from 'react'

export default function Reviews() {
  return (
    <div>Reviews</div>
  )
}
